import { Routes } from '@angular/router';

import { AuthGuard } from './services/auth/auth.guard';
import { AppLayoutComponent } from './layout/app.layout.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: HomeComponent },
      {
        path: 'chat',
        loadComponent: () =>
          import('./pages/chat/chat.component').then((m) => m.ChatAppComponent),
      },
      {
        path: 'manage-network',
        loadComponent: () =>
          import('./pages/manage-network/manage-network.component').then(
            (m) => m.ManageNetworkComponent
          ),
      },
      {
        path: 'manage-files',
        loadComponent: () =>
          import('./pages/user-files/user-files.component').then(
            (m) => m.UserFilesComponent
          ),
      },
      {
        path: 'emergency-alerts',
        loadComponent: () =>
          import('./pages/emergency-alerts/emergency-alerts.component').then(
            (m) => m.EmergencyAlertsComponent
          ),
      },
    ],
  },
  {
    path: 'delete-account',
    loadComponent: () =>
      import('./pages/delete-user/delete-user.component').then(
        (m) => m.DeleteUserComponent
      ),
  },
  {
    path: 'thank-you',
    loadComponent: () =>
      import('./pages/thank-you/thank-you.component').then(
        (m) => m.ThankYouComponent
      ),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./pages/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent
      ),
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('./pages/contact-us/contact-us.component').then(
        (m) => m.ContactUsComponent
      ),
  },
   {
    path: 'reset-password/:token',
    loadComponent: () =>
      import('./pages/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: 'login',
    component: LoginComponent,
  },
];
